<template>
  <div id="root">
    <v-card class="search-map" flat>
      <v-toolbar dense floating>
        <gmap-autocomplete
            @place_changed="searchAddress($event)"
            id="pac-input"
            placeholder="Pesquisar"
        />
        <v-btn icon>
          <i class="fas fa-search"></i>
        </v-btn>
      </v-toolbar>
    </v-card>
    <gmap-map
        :options="{mapTypeId:'roadmap',mapTypeControl:false}"
        :center="center"
        :zoom="zoom"
        @zoom_changed="updateZoom($event)"
        @bounds_changed="updateMapBounds($event)"
        style="width: 100%; height: 600px"
    >
      <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false"
      >
      </gmap-info-window>
      <gmap-polygon
          v-if="zoom <= 18 && zoom >= 14"
          :clickable="true"
          :draggable="false"
          :editable="false"
          :key="i"
          :options="{
            fillColor: '#0099FF',
            fillOpacity: 0.7,
            strokeColor: '#AA2143',
            strokeOpacity: 0.8,
            strokeWeight: 1,
          }"
          :paths="poly"
          ref="polygon"
          v-for="(poly, i) in paths"
      >
      </gmap-polygon>
      <gmap-cluster
          v-if="zoom >= 19"
          :minimumClusterSize="5"
      >
        <gmap-marker
            :key="i"
            v-for="(m,i) in visibleMarkers"
            :position="m.position"
            :clickable="true"
            @click="toggleInfoWindow(m,i)"
            :icon="{
              url: m.url,
            }"
            :label="m.label"
        >
        </gmap-marker>
      </gmap-cluster>
    </gmap-map>
  </div>
</template>

<script>
import Vue from 'vue';
import {gmapApi} from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

Vue.use(require('vue2-google-maps'), {
  load: {
    key: process.env.VUE_APP_KEY_GOOGLE_MAPS,
    libraries: 'places,drawing,visualization',
    installComponents: false,
  },
});
export default {
  name: "VueMap",
  components: {GmapCluster},
  props: [
    "markerList",
    "polygonList",
    "centerOv",
    "draggableOv",
    "searchOv",
    "plates"
  ],
  computed: {
    google: gmapApi
  },
  data: function () {
    return {
      zoom: 19,
      zoomTimeout: null,
      boundTimeout: null,
      mapBounds: {
        north: null,
        south: null,
        east: null,
        west: null
      },
      currentLocation: {
        lat: 0,
        lng: 0
      },
      markers: [],
      visibleMarkers: [],
      center: {
        lat: -25.0994,
        lng: -50.1583
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      paths: [],
    }
  },
  watch: {
    markerList: {
      immediate: true,
      deep: true,
      handler() {
        this.markers = this.markerList;
        this.filterVisibleMarkers();
      }
    },
    polygonList: {
      immediate: true,
      deep: true,
      handler() {
        this.getPaths();
      }
    },
    centerOv: {
      immediate: true,
      deep: true,
      handler() {
        this.center = this.centerOv;
      }
    }
  },
  mounted: function () {
    this.geolocation();
  },
  methods: {
    updateZoom(newZoom) {
      clearTimeout(this.zoomTimeout)
      this.zoomTimeout = setTimeout(() => {
        this.zoom = Math.max(10, Math.min(20, newZoom))
      }, 100)
    },
    updateMapBounds(event) {
      clearTimeout(this.boundTimeout)
      this.boundTimeout = setTimeout(() => {
        this.mapBounds = this.getBounds(event);
        this.filterVisibleMarkers();
      }, 100)
    },
    getBounds(event) {
      const ne = event.getNorthEast();
      const sw = event.getSouthWest();

      return {
        north: ne.lat(),
        south: sw.lat(),
        east: ne.lng(),
        west: sw.lng(),
      }
    },
    searchAddress: function (place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      if (this.draggableOv === true) {
        this.markers = [{
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        }];
      }
      this.$emit('searchResult', this.center);
    },
    geolocation: function () {
      navigator.geolocation.watchPosition((position) => {
        if (this.checkExistMarker() === null) {
          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
        } else {
          this.markers.splice((this.checkExistMarker()), 1);
        }
        this.markers.push(
            {
              url: require('@/assets/imgs/current-location.png'),
              infoText: '<strong>Você esta aqui!</strong>',
              scaledSize: {width: 1, height: 1},
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            }
        )
      }, () => {
      }, {enableHighAccuracy: true,});
    },
    checkExistMarker: function () {
      var marker_exist = null;
      this.markers.forEach(function (item, index) {
        if (item.infoText === '<strong>Você esta aqui!</strong>') {
          marker_exist = index;
        }
      });
      return marker_exist;
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    },
    getPaths() {
      this.paths = [];
      this.polygonList.map((poly) => {
        const path = poly.coordinates.map((linearRing) =>
            linearRing
                .slice(0, linearRing.length - 1)
                .map(([lng, lat]) => ({lat, lng}))
        );
        this.paths.push(path[0]);
      });
    },
    filterVisibleMarkers() {
      if (!this.mapBounds || !this.markerList.length) {
        this.visibleMarkers = this.markerList;
        return;
      }

      this.visibleMarkers = this.markerList.filter(marker => {
        return this.isMarkerInBounds(marker.position);
      });
    },
    isMarkerInBounds(position) {
      if (!position || !this.mapBounds) {
        return false;
      }

      return position.lat <= this.mapBounds.north &&
          position.lat >= this.mapBounds.south &&
          position.lng <= this.mapBounds.east &&
          position.lng >= this.mapBounds.west;
    },
  }
}
</script>

<style scoped>
.search-map {
  position: absolute;
  margin: 10px 0 0 10px;
  z-index: 2;
}

.v-toolbar__content, .search-map, #pac-input {
  width: 400px;
}

@media only screen and (max-width: 500px) {
  .v-toolbar__content, .search-map, #pac-input {
    width: 80px;
  }
}

</style>
